import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AdminDashboard from "./AdminDashboard.js/index.js";
import UserDashboard from "./Userdashboard.js/index.js";
const DashboardPage = () => {
  const userRole = useSelector((state) =>
    state.auth.user?.is_superuser ? "admin" : "user" || "user"
  );
  
  switch (userRole) {
    case "admin":
      return <AdminDashboard />;
    case "user":
      return <UserDashboard />;
    default:
      return <div>No dashboard available for your role.</div>;
  }
};

export default DashboardPage;
